import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

var PrettyTrend = function(filter) {
	let dateTimeOperatorCode = _.camelCase(filter.dateTimeOperator)
	let messageCode = `report.filter.pretty.trend.${filter.operator}.${dateTimeOperatorCode}`
	var args = [messageCode].concat(this.periodLabels(filter))
	return i18n.get.apply(i18n, args)
}

export default PrettyTrend

PrettyTrend.__filename__ = 'reports/common/filter/pretty-trend.js'
